import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../assets/styles/components/detail-center.mobile/detail-center.mobile.scss'
import classnames from 'classnames';

import QuoteMobile from './DetailPage.mobile/Quote.mobile.js'
import CommentMobile from './DetailPage.mobile/Comment.mobile'


class DetailCenterMobile extends Component {
	constructor(props) {
		super(props)
		this.state = {
			selectBolck: ['common_quote','market_summary','market_index','market_financials','market_comment'],
			currentSelect: 0,
		}
	}
	render() {
		const {language} = this.props
		const {selectBolck,currentSelect} = this.state
		return (
			<div className='detail-center-mobile'>
				<div className='detail-center-mobile-headselect'>
				{selectBolck.map((item,index)=>{
					return(
						<div className={classnames('headslect-single',currentSelect == index && 'active')}
						    key={item}
								onClick={()=>{this.handleSelectBlock(index)}} >{language[item]}</div>
					)
				})}
				</div>

				<div className='detail-center-mobile-content' >
					{currentSelect == 0 && <QuoteMobile></QuoteMobile> }
					{/* {currentSelect == 4 && <CommentMobile innerRef={e => this.CommentRef = e} ></CommentMobile>} */}
				</div>
			</div>
		)
	}

	handleSelectBlock = (index) =>{
		this.setState({currentSelect:index})
	}

}


export default connect(state => ({
	language: state.app.language,
}),
	dispatch => ({

	}))(DetailCenterMobile)